module.exports = __webpack_public_path__ + "static/media/check-icon.9bac5cf2.svg";